//Strings
import { Strings } from "../../resources/i18n/i18n";

export const DEFAULT_LIST = [Strings("selectStatus")];
